import { PropTypes } from "prop-types";
import { useQuery } from "react-query";
import { StyledTableContainer, StyledTableHeader } from "../../styles/StyledUnit/StyledContent";
import { Button } from "../Button";
import AddIcon from "../../assets/img/icons/add.svg";
import { useState } from "react";
import Modal from "../Modal";
import { ConfirmationModal } from "../ConfirmationModal";
import { QueryLoader } from "../Loader";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import AdminTableRow from "./AdminTableRow";
import { StyledModal } from "../../styles/StyledModal";

export default function AdminTable({ possibleToDelete, getFunc, addFunc, editFunc, name, deleteFunc }) {
	const { axiosPrivate } = useAxiosPrivate();
	const { isLoading, isError, error, data, refetch } = useQuery([`${name}AdminTab`], () => getFunc(axiosPrivate));
	const [addNew, setAddNew] = useState(false);
	const [modalIsOpen, setModalIsOpen] = useState(false);
	const [deletedId, setDeletedId] = useState(null);

	const handleDelete = async (id) => {
		await deleteFunc(axiosPrivate, refetch, id);
	};

	if (!isLoading) {
		if (error) console.log(error);
		if (data.status === 403) {
			return <h6>User not able to preview matters</h6>;
		}
	}

	return (
		<>
			{!isLoading && !isError ? (
				<>
					<StyledTableHeader>
						<span>{name}</span>
						<span>Action</span>
					</StyledTableHeader>
					<StyledTableContainer>
						{addNew && (
							<AdminTableRow
								refetch={refetch}
								setAddNew={setAddNew}
								edit={true}
								data={{}}
								possibleToDelete={possibleToDelete}
								addFunc={addFunc}
								editFunc={editFunc}
								deleteFunc={deleteFunc}
							/>
						)}
						{data.map((e, i) => (
							<AdminTableRow
								refetch={refetch}
								key={i}
								data={e}
								openModal={() => setModalIsOpen(true)}
								setDeletedId={setDeletedId}
								possibleToDelete={possibleToDelete}
								addFunc={addFunc}
								editFunc={editFunc}
								deleteFunc={deleteFunc}
							/>
						))}
						{data.length < 1 && <h6>No categories found</h6>}
						<Button icon={AddIcon} onClick={() => setAddNew(true)}>
							Add {name}
						</Button>
					</StyledTableContainer>
				</>
			) : (
				<QueryLoader />
			)}
			<Modal
				isOpen={modalIsOpen}
				onRequestClose={() => {
					setDeletedId(null);
					setModalIsOpen(false);
				}}
				style={StyledModal}
				appElement={document.getElementById("app")}
			>
				<ConfirmationModal
					handleDelete={() => handleDelete(deletedId)}
					deletedId={deletedId}
					closeModal={() => {
						setDeletedId(null);
						setModalIsOpen(false);
					}}
				/>
			</Modal>
		</>
	);
}

AdminTable.propTypes = {
	possibleToDelete: PropTypes.bool,
	getFunc: PropTypes.func,
	addFunc: PropTypes.func,
	editFunc: PropTypes.func,
	deleteFunc: PropTypes.func,
	name: PropTypes.string,
};

AdminTable.defaultProps = {
	possibleToDelete: false,
};
